import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function fieldDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/field/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
